@if (company) {
<nav class="md:hidden fixed bottom-0 z-50
          h-[70px] flex w-full flex-row justify-around items-center text-white bg-green-800"
    >
    <div
      (click)="callTelephonNumber()"
      class="flex flex-col items-center justify-center bg-green-300 active:bg-green-800 w-full h-full pl-12">
      <mat-icon svgIcon="core:phone"></mat-icon>
      <span i18n="request call" class="text-sm">Call</span>
    </div>
    @if (company.accountType === accountType.customer) {
      <div
        (click)="openRequestInfoMobile(requestType.message)"
        class="flex flex-col items-center justify-center bg-green-400 active:bg-green-800 w-full h-full">
        <mat-icon svgIcon="stand:message"></mat-icon>
        <span i18n="message" class="text-sm">Message</span>
      </div>
    }
    <div (click)="getDirection()"
      class="flex flex-col items-center justify-center bg-green-500 active:bg-green-800 w-full h-full">
      <mat-icon svgIcon="stand:directions"></mat-icon>
      <span i18n="request guide to" class="text-sm">Directions</span>
    </div>
    <div (click)="openWebsite()"
      class="flex flex-col items-center justify-center bg-green-600 active:bg-green-800 w-full h-full">
      <mat-icon svgIcon="stand:language"></mat-icon>
      <span i18n="request guide to" class="text-sm">Website</span>
    </div>
  </nav>
}
